var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkWebIdIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.933 16H.853A.853.853 0 010 15.147V.853C0 .383.382 0 .853 0h14.08C15.523 0 16 .478 16 1.067v13.866c0 .59-.478 1.067-1.067 1.067z",
    fill: "#FBEE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.765 7.179a.704.704 0 10-1.109.554v1.974l-2.827 1.685-2.826-1.685V6.304L7.86 4.608l.747.363c0 .01-.01.032-.01.042a.693.693 0 10.693-.693.619.619 0 00-.278.064l-1.226-.65-3.552 2.143v4.256l3.594 2.134 3.584-2.134V7.765a.672.672 0 00.352-.586z",
    fill: "#322F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.419 7.093h.938c.15-.008.3.018.438.075.11.05.208.122.288.213.076.098.13.21.16.331.03.13.045.262.042.395.007.17-.015.339-.064.501a.896.896 0 01-.213.299.576.576 0 01-.277.16 1.259 1.259 0 01-.374.053H5.42V7.093zm.629.459v1.11h.16a.597.597 0 00.277-.043.299.299 0 00.128-.15.981.981 0 00.043-.352.779.779 0 00-.096-.448.48.48 0 00-.352-.117h-.16zM7.435 7.093h.597l.213 1.142.31-1.142h.597l.31 1.142.213-1.142h.597L9.824 9.12h-.619l-.352-1.27-.352 1.27h-.618z",
    fill: "#322F31"
  }))));
}
export default SvgDarkWebIdIco;